import React, { FC } from 'react';
import { DashboardType, EMBEDDED_DASHBOARD } from '@/features/dashboard/types';
import { Button, Tooltip, TrevorIcon } from '@trevor/ui-components';
import { useLazyDownloadCsvQuery } from '@/features/customer-facing-dashboards/apiSlice';
import { useDashboardId } from '@/hooks';
import { useSelector } from 'react-redux';
import { getDashboardsState } from '@/store-selectors';
import { userAction } from '@/util/helpers/ajax-helpers';
import { downloadFile } from '@/util/Download';
import DashboardChartWidget from '@/util/DashboardChartWidget';

type EmbeddedDownloadCsvProps = {
  dashboardType: DashboardType;
  widget: DashboardChartWidget;
  fileName: string;
};
export const EmbeddedDownloadCsv: FC<EmbeddedDownloadCsvProps> = ({
  dashboardType,
  widget,
  fileName,
}) => {
  const [trigger] = useLazyDownloadCsvQuery();
  const dashboardId = useDashboardId();
  const dashboards = useSelector(getDashboardsState);

  if (dashboardType !== EMBEDDED_DASHBOARD) {
    return null;
  }

  const tooltipId = `downloadSVG_${widget.key}`;

  const noDataAvailable = dashboards.viewsAwaitingResults.some(
    (v) => v._series === widget.series,
  );

  const handleDownloadCsv = async () => {
    const { data } = await trigger({
      dashboardId,
      seriesId: widget.series,
      refreshId: dashboards.refreshId,
    });

    downloadFile(data as Blob, `${fileName}.csv`);
    userAction('use-download-embedded-dashboard');
  };

  return (
    <>
      <Tooltip place="top" id={tooltipId}>
        Download CSV
      </Tooltip>
      <Button
        disabled={noDataAvailable}
        onClick={handleDownloadCsv}
        data-tooltip-id={tooltipId}
        id="download-button"
        size="small"
        variant="secondary"
        icon={<TrevorIcon name="download" />}
      />
    </>
  );
};
